var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHisIconsMenuBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#222B45"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.368 10.667c.348 0 .632.284.632.632v.068c0 .348-.284.633-.632.633H2.632C2.284 12 2 11.715 2 11.367V11.3c0-.348.284-.632.632-.632zm0-3.334c.348 0 .632.285.632.633v.068c0 .348-.284.633-.632.633H2.632c-.348 0-.632-.285-.632-.633v-.068c0-.348.284-.633.632-.633zm0-3.333c.348 0 .632.285.632.633V4.7c0 .348-.284.632-.632.632H2.632C2.284 5.333 2 5.05 2 4.701v-.068C2 4.285 2.284 4 2.632 4z",
    transform: "translate(-1200 -166) translate(1176 147.5) translate(24 19)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHisIconsMenuBlack);
export default __webpack_public_path__ + "static/media/icon-his-icons-menu-black.dc17546f.svg";
export { ForwardRef as ReactComponent };